import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { getAppRoutesArray } from './app-routes';
import { where } from '../framework/utils/collection';
import { ResourceNotFoundPage } from '../pages/not-found';
import { useEventNotification } from '../framework/services/event-notification';
import { AppRoutes } from '../app-admin/app-routes';
import { AdminAppEvents } from './events';
import { usePageManager } from './services/page-manager';

const subscriberId = 'Base.AppPages';

export const AppPages: React.FunctionComponent = () => {
  const topLevelRoutes = where(getAppRoutesArray(), route => route.topLevel);
  usePageManager();
  const history = useHistory();

  useEventNotification(() => history.push(AppRoutes.signIn.url()), [history], AdminAppEvents.ForceSignIn, subscriberId);

  return (
    <Switch>
      {topLevelRoutes.map(route => <Route key={route.key} path={route.urlTemplate} exact={route.exact} component={route.component} />)}
      <Route path={'*'} component={ResourceNotFoundPage} />
    </Switch>
  );
};
